import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  DOCUMENT_TYPES,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/control-attachments`;

export interface SetFileAttachmentInfoArgs {
  fileId: string;
  fileAttachmentId: string;
  name: string;
  extension: string;
  documentType?: DOCUMENT_TYPES;
}

export default async function setFileAttachmentInfo(
  payload: SetFileAttachmentInfoArgs,
): Promise<BackResponse<string> | BackResponseFailure> {
  try {
    const { fileAttachmentId, fileId, extension, name, documentType } = payload;
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

    const response = await apiCall<BackResponse<string>>(url, {
      method: SUPPORTED_METHODS.POST,
      json: {
        name,
        extension,
        fileAttachmentId,
        documentType,
      },
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
